import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { DESIGNS_DATA } from '../features/designs/domain/infrastructure/designs.data';
import { PartnerStudioResource } from '../features/partner/domain/infrastructure/partner-cabinet.resource';
import { withTimeout } from '../features/projects/domain/utils/with-timeout.util';
import { ACCESS_READ_LIMIT_MS } from './route-wait';

// The pack is the photographer's own upload, but working on it is earned by our moderation — so the editor
// answers the route, not the menu: a hand-typed URL on a pack still in review lands back in its wizard.
export const designApprovedGuard: CanActivateFn = async route => {
  const router = inject(Router);
  const data = inject(DESIGNS_DATA);
  const studios = inject(PartnerStudioResource);
  const designId = route.paramMap.get('designPackageId');

  // A partner studio owns no /designs screens — its packs live in the cabinet, so its bounce lands there.
  const partner = !!(await studios.myStudio());
  const wizard = partner ? '/partner/templates/new' : '/designs/new';
  const list = partner ? '/partner/templates' : '/designs';
  if (!designId) return router.createUrlTree([list]);

  // Молчание сервера — тот же отказ, что и сбой: обратно к списку, а не вечная вуаль.
  return withTimeout(data.getReviewStatus(designId), ACCESS_READ_LIMIT_MS)
    .then(status => status === 'approved' || router.createUrlTree([wizard], { queryParams: { design: designId } }))
    .catch(() => router.createUrlTree([list]));
};
